module.exports = __webpack_public_path__ + "static/media/DT.fbbedb1a.png";